module.exports = __webpack_public_path__ + "static/img/MP.c45404cd.jpg";